import React from 'react';
import { Flex, Loader } from '@grubhubprod/gh-cookbook-react';
import { useDataTableContext } from 'src/components/DataTable/components/DataTableProvider/hooks/useDataTableContext';

export const DataTableLoading: React.FC = () => {
  const { isLoading } = useDataTableContext();

  if (!isLoading) {
    return null;
  }

  return (
    <Flex
      alignItems="center"
      justifyContent="center"
      position="absolute"
      width="100%"
      height="100%"
      zIndex={10}
      top={0}
      left={0}
    >
      <Loader size="md" />
    </Flex>
  );
};
